import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2xs10,
    GridItem3,
    GridItem3xs10,
    GridItem3xs10NotIsXsDownScreen,
    GridItem4,
    GridItem5,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import familiaresList from '../../../business-rules/List/familiaresList'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoProjetoVidaSonho,
    rowPertentePageProjetoVidaSonho,
    setPageInclusaoProjetoVidaSonho,
    Familiar,
    TipoProjetoVidaSonho,
    IconButtonClearEntradaDadosProjetoVidaSonho,
    Valor,
    IdadeRealizacao,
    AnoRealizacao,
    TracarMeta,
    MesAnoInicioAcumulacao,
    MesAnoFimAcumulacao,
    MesRealizacao,
    DadosInvalidosTracarMeta,
    Descricao,
} from '../projetoVidaSonho-form/ProjetoVidaSonhoCompProjetoVidaSonho'

import {
    incrementaContProjetoVidaSonho,
    processaRegistrosDefaultIniciaisProjetoVidaSonho,
    calculaTotaisProjetoVidaSonho,
} from '../projetoVidaSonho-form/ProjetoVidaSonhoServiceProjetoVidaSonho'

import {
    processaFormRegistrosDefaultIniciaisSortAscFamiliar
} from './FormService'

import ProjetoVidaSonhoFormProjetoVidaSonhoItem from '../projetoVidaSonho-form/ProjetoVidaSonhoFormProjetoVidaSonhoItem'



const FormFormProjetoVidaSonho = ({ values, handleChange, setFieldValue, linhaTipoLicenca, title }) => {

    const [expandiu, setExpandiu] = useState(false)
    
    calculaTotaisProjetoVidaSonho(values)

    useSingleton(async () => {

        processaFormRegistrosDefaultIniciaisSortAscFamiliar(values, values.totalProjetoVidaSonho, processaRegistrosDefaultIniciaisProjetoVidaSonho,
            values.projetoVidaSonho)

        values.pageProjetoVidaSonho = obtemPage(values.pageProjetoVidaSonhoList, HARDCODE.idFamiliarPage)
    })

    salvaPage(values.pageProjetoVidaSonho, values.pageProjetoVidaSonhoList, HARDCODE.idFamiliarPage)

    values.projetoVidaSonhoPagination = values.projetoVidaSonho

    const isXsDownScreen = IsXsDownScreen()



    return (
        <FieldArray name="projetoVidaSonho">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.projetoVidaSonho?.map((item, ind) => {

                            if (rowPertentePageProjetoVidaSonho(values, ind)) {

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem3xs10>
                                                <GridContainer>
                                                    <GridItem6>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem6>
                                                    
                                                    <GridItem6>
                                                        <TipoProjetoVidaSonho
                                                            TextFieldNumberSelectTipoProjetoVidaSonho={
                                                                TextFieldNumberSelect
                                                            }
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem3xs10>

                                            {item.tipoProjetoVidaSonho
                                                ?
                                                    <GridItem3xs10>
                                                        <GridContainer>
                                                            <GridItem5>
                                                                <Valor
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem5>
                                                            {item.valor !== item.valorAcumulacaoJaRealizado && (
                                                                <>
                                                                    {!item.anoRealizacao && item.familiar !== HARDCODE.idFamiliarFamilia && (
                                                                        <GridItem3>
                                                                            <IdadeRealizacao
                                                                                item={item}
                                                                                ind={ind}
                                                                                handleChange={handleChange}
                                                                                expandiu={expandiu}
                                                                            />
                                                                        </GridItem3>
                                                                    )}
                                                                    {!item.idadeRealizacao && (
                                                                        <GridItem3>
                                                                            <AnoRealizacao
                                                                                item={item}
                                                                                ind={ind}
                                                                                handleChange={handleChange}
                                                                                expandiu={expandiu}
                                                                            />
                                                                        </GridItem3>
                                                                    )}
                                                                    {(item.idadeRealizacao || item.anoRealizacao) &&
                                                                    linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                                                        <GridItem4>
                                                                            {!expandiu && (
                                                                                <TracarMeta
                                                                                    values={values}
                                                                                    item={item}
                                                                                    ind={ind}
                                                                                    handleChange={handleChange}
                                                                                />
                                                                            )}
                                                                        </GridItem4>
                                                                    )}
                                                                </>
                                                            )}
                                                        </GridContainer>
                                                    </GridItem3xs10>
                                                :
                                                    <GridItem3xs10NotIsXsDownScreen/>
                                            }

                                            {item.tracarMeta
                                                ?
                                                    <GridItem3xs10>
                                                        <GridContainer>
                                                            <GridItem4>
                                                                <MesAnoInicioAcumulacao
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem4>
                                                            <GridItem4>
                                                                <MesAnoFimAcumulacao
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem4>
                                                            <GridItem4>
                                                                <MesRealizacao
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem4>
                                                        </GridContainer>

                                                        <DadosInvalidosTracarMeta
                                                            values={values}
                                                            item={item}
                                                        />
                                                    </GridItem3xs10>
                                                :
                                                    <GridItem3xs10NotIsXsDownScreen />
                                            }

                                            <GridItem2xs10>
                                                <Descricao
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                    expandiu={expandiu}
                                                />
                                            </GridItem2xs10>

                                            <GridItem1xs2>
                                                <GridContainer>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <CustomizedDialogsPopup
                                                            maxWidth="sm"
                                                            popupTitle={title}
                                                            tooltipTitle={LABEL.expandir}
                                                            PopupButton={IconButtonMaisInformacoes}
                                                            popupButtonDestaque={false}
                                                            DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                                                            popupComponent={
                                                                <ProjetoVidaSonhoFormProjetoVidaSonhoItem
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={arrayHelpers}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    item={item}
                                                                    ind={ind}
                                                                    simplificado={true}
                                                                />
                                                            }
                                                            open={setExpandiu}
                                                            afterClose={setExpandiu}
                                                        />
                                                    </GridItem6>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <IconButtonClearEntradaDadosProjetoVidaSonho
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            ind={ind}
                                                            arrayHelpers={arrayHelpers}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem1xs2>
                                        </GridContainer>
                                        
                                        {isXsDownScreen && values.projetoVidaSonhoPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoProjetoVidaSonho
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    <GridContainerGridItemButtonIncluirLinha>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirProjetoVidaSonho} 
                            align='right'
                            disabled={familiaresList(values).length === 0 ? true : false}
                            onClick={() =>
                                {
                                    incrementaContProjetoVidaSonho(values)
                                    arrayHelpers.push({
                                        id: values.contProjetoVidaSonho,
                                        familiar: HARDCODE.idFamiliarCliente,
                                    })
                                    setPageInclusaoProjetoVidaSonho(values, setFieldValue)
                                }
                            }
                        />
                    </GridContainerGridItemButtonIncluirLinha>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormProjetoVidaSonho